import {USER_INFO_CBOT} from '../../constans';
import RSAA from "redux-api-middleware/es/RSAA";
import userInfoSave from "../../utils/userInfoSave";
import {SERVER_CBOT} from "../../constans/api_config";
import {MY_CBOT_FAILURE, MY_CBOT_REQUEST, MY_CBOT_SUCCESS} from "./LoginType";

const GetMyCBotAction = (token) => ({

    [RSAA]: {
        endpoint: `${SERVER_CBOT}/api/me`,
        method: 'GET',
        headers: {"Content-Type": "application/json", "Authorization": token},
        types: [
            MY_CBOT_REQUEST,
            {
                type: MY_CBOT_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            userInfoSave(json.data, USER_INFO_CBOT);
                        });

                        return {
                            "code": 0,
                            "type": MY_CBOT_SUCCESS
                        }
                    }
                }
            },
            MY_CBOT_FAILURE
        ]
    }
});

export {GetMyCBotAction}